import { useState } from 'react';
import { Button, Card, Field, Input, PageHeader, Textarea } from '../components/ui';
import { CreatorsAPI } from '../services/endpoints/admin';
import { useDispatchAction } from '../hooks/useDispatchAction';
import './common.css';

export function CreatorsPage() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [bio, setBio] = useState('');
  const { run, busy } = useDispatchAction();

  const submit = async () => {
    const addr = email.trim();
    if (!addr) return;
    const res = await run(`Grant creator to ${addr}`,
      () => CreatorsAPI.create(addr, name.trim() || undefined, bio.trim() || undefined));
    if (res) { setEmail(''); setName(''); setBio(''); }
  };

  return (
    <div>
      <PageHeader
        eyebrow="15 — CREATORS"
        title={<>Anoint a <em>creator</em>.</>}
        lede="Grant creator status to an existing user by email. This adds the CREATOR role and a creator profile, so the app shows them the Create studio. Re-running for the same email just updates their name/bio."
      />

      <Card>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, maxWidth: 480 }}>
          <Field label="User email" hint="The user must already have an account.">
            <Input
              type="email"
              value={email}
              placeholder="creator@example.com"
              autoFocus
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
            />
          </Field>
          <Field label="Display name" hint="Optional — shown as the class author.">
            <Input value={name} placeholder="Babaláwo Adéyẹmí" onChange={(e) => setName(e.target.value)} />
          </Field>
          <Field label="Bio" hint="Optional.">
            <Textarea value={bio} rows={3} placeholder="A short bio…" onChange={(e) => setBio(e.target.value)} />
          </Field>
          <div>
            <Button tone="ember" disabled={busy || !email.trim()} onClick={submit}>
              {busy ? 'Creating…' : 'Create creator profile'}
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
